import { SsMount } from 'src/js/dom/mount.js';
import { velocity } from 'src/js/lib/velocity.js';
import { throttle } from 'lodash';

export class SsBtn extends SsMount {
  constructor ( elm, type, parent ) {
    super( elm );
    this.type = type;
    this.clickID = throttle( this.clickLsn.bind( this ), 100 );
    this.parent = parent;
  }

  clickLsn () {
    if ( this.clickable ) {
      this.parent.emit( 'btn:clicked', this.type );
    }
  }

  onClick () {
    this.elm.addEventListener( 'click', this.clickID );
  }

  offClick () {
    this.elm.removeEventListener( 'click', this.clickID );
  }

  set disable ( bool ) {
    const className = 'disabled';
    ( bool )
      ? this.$.addClass( className )
      : this.$.removeClass( className );
    this.clickable = ! bool;
  }
}

export class SsConsole extends SsMount {
  constructor ( elm ) {
    super( elm );
    this.shown = false;
    this.vdefs = () => { return {
      duration: 300,
      easing: 'easeInOutSine',
    }};
    this.children = {
      deno: elm.querySelector( '.denominator' ),
      nume: elm.querySelector( '.numerator' ),
    };
    this.btns = [
      new SsBtn( elm.querySelector( '.ss-icon-prev' ), 'prev', this ),
      new SsBtn( elm.querySelector( '.ss-icon-peke' ), 'peke', this ),
      new SsBtn( elm.querySelector( '.ss-icon-next' ), 'next', this ),
    ];
    this.$.on( 'click', evt => {
      evt.preventDefault();
    });
  }

  show () {
    if ( ! this.shown )
    {
      this.shown = true;
      return velocity( this.elm, {
        props: {
          translateX: [ '0%', '100%' ],
        },
        opts: this.vdefs(),
        cb: () => {
          this.onClicks();
        },
      });
    }
    else
    {
      return Promise.resolve();
    }
  }

  hide () {
    if ( this.shown )
    {
      this.offCliks();
      return velocity( this.elm, {
        props: {
          translateX: [ '100%', '0%' ],
        },
        opts: this.vdefs(),
        cb: () => {
          this.shown = false;
        },
      });
    }
    else
    {
      return Promise.resolve();
    }
  }

  onClicks () {
    for ( let btn of this.btns ) {
      btn.onClick();
    }
  }

  offCliks () {
    for ( let btn of this.btns ) {
      btn.offClick();
    }
  }

  set deno ( num ) {
    this.max = Number( num );
    this.children.deno.textContent = num.toString();
  }

  set nume ( num ) {
    this.children.nume.textContent = num.toString();
    this.btns.forEach( btn => {
      btn.disable = false;
    });
    if ( num === 1 )
    {
      this.btns[ 0 ].disable = true;
    }
    else if ( num === this.max )
    {
      this.btns[ 2 ].disable = true;
    }
  }
}
